import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyDsdlFTYw7fP8MFmSZEVKcf0rmkHLhEijk",
  authDomain: "marine-group-transport.firebaseapp.com",
  projectId: "marine-group-transport",
  storageBucket: "marine-group-transport.firebasestorage.app",
  messagingSenderId: "937443659560",
  appId: "1:937443659560:web:5b5959b352c8f1624d0a1d",
  measurementId: "G-JEDKFZBL26"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDEgmToV9TMqC-_gctGb7U2c2riG8zVckE",
//   authDomain: "mgtspl-uat.firebaseapp.com",
//   projectId: "mgtspl-uat",
//   storageBucket: "mgtspl-uat.firebasestorage.app",
//   messagingSenderId: "124704262984",
//   appId: "1:124704262984:web:bb3a7618d16356401c817d",
//   measurementId: "G-7RQK24YDL8"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyCgFj4NnkmWjpHVjY7psEYXfcS_EeFurlI",
//   authDomain: "tntresearchagent.firebaseapp.com",
//   projectId: "tntresearchagent",
//   storageBucket: "tntresearchagent.firebasestorage.app",
//   messagingSenderId: "868604882105",
//   appId: "1:868604882105:web:d8b96b54e7d66966343f68",
//   measurementId: "G-LQHD9VKQJS"
// };


const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);